module.exports = __webpack_public_path__ + "media/Isabelle_d_Ornano.642aa5e9.mp4";